<template>
    <div v-cloak role="main">
        <stripe-pricing-table pricing-table-id="prctbl_1Q3ra2LUgmmDlShmAtmknXJE" publishable-key="pk_test_kSALC1zzott1ubjImcTbIvUw">
        </stripe-pricing-table>
    </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: 'Pricing',
  data() {
    return {
      countryCode: null,
      countryPricing: null,
      pricingData: null,
    };
  },
};
</script>
